import React, { Component, ErrorInfo } from "react";

import ClientErrorPage from "./state-pages/ClientErrorPage";

type TProps = {
  children: React.ReactNode;
};

type TState = {
  hasError: boolean;
  error: string;
  errorInfo: ErrorInfo;
  retryCount: number;
};

export class ErrorBoundary extends Component<TProps, TState> {
  public errorDetail: ErrorInfo = {};
  constructor(props: TProps) {
    super(props);

    this.state = {
      hasError: false,
      error: "",
      errorInfo: {},
      retryCount: 0,
    };
  }

  static getDerivedStateFromError(error: Error): {
    hasError: boolean;
    error: string;
  } {
    return {
      hasError: true,
      error: error?.toString(),
    };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    // this.setState({
    //   hasError: true,
    //   errorInfo: info,
    //   error: info?.componentStack || "",
    // });
    this.errorDetail = info;

    // More robust chunk error detection
    const isChunkError =
      error.name === "ChunkLoadError" ||
      error.message?.includes("Loading chunk") ||
      error.message?.includes("ChunkLoadError") ||
      error.message?.includes("Failed to fetch dynamically imported module") ||
      /loading.*chunk.*failed/i.test(error.message);

    if (isChunkError) {
      if (this.state.retryCount < 3) {
        this.setState((prevState) => ({
          retryCount: prevState.retryCount + 1,
        }));
        window.location.reload();
      }

      return;
    }
  }

  // https://react.dev/reference/react/Component#catching-rendering-errors-with-an-error-boundary
  render(): React.ReactNode {
    if (this.state.hasError) {
      return process.env.NODE_ENV === "development" ? (
        <div className='error-boundary'>
          <p>Oops! Something went wrong 😥.</p>
          <span onClick={() => window?.location?.reload()}>Reload</span>
          <details open>
            <summary className='pb-1 text-xl font-medium'>Error Detail</summary>
            <div className='pb-1 font-medium'>
              {this.state?.error || ""}
              <br />
              <hr />
              {this.errorDetail?.componentStack || ""}
            </div>
          </details>
        </div>
      ) : (
        <ClientErrorPage />
      );
    }

    return this.props.children;
  }
}
